import apiAxios from '@/api/base'

export default {
    findChannel (data) {
        return apiAxios.post('/channels', data)
    },
    getChannelPlaylists (data) {
        return apiAxios.post('/channel-playlists', data)
    }
}